import { useEffect, useState } from 'react';

import MoonIcon from '../../../assets/airkey-theme-toggle-moon.svg?react';
import SunIcon from '../../../assets/airkey-theme-toggle-sun.svg?react';
import { useTheme } from '../../../contexts/useTheme';
import './ThemeToggle.scss';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [isLightTheme, setIsLightTheme] = useState(theme === 'light');

  useEffect(() => {
    setIsLightTheme(theme === 'light');
  }, [theme]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleTheme();
    }
  };

  return (
    <>
      <label htmlFor="toggle-switch" className="toggle-switch-label">
        <input
          type="checkbox"
          checked={isLightTheme}
          onChange={toggleTheme}
          onKeyDown={handleKeyDown}
          id="toggle-switch"
          className="toggle-switch-input"
          aria-label={`Switch to ${isLightTheme ? 'dark' : 'light'} theme`}
          role="switch"
          aria-checked={isLightTheme}
        />
        <div className="toggle-switch-track">
          <div className="toggle-switch-thumb"></div>
          <MoonIcon className="toggle-icon moon-icon" aria-hidden="true" />
          <SunIcon className="toggle-icon sun-icon" aria-hidden="true" />
        </div>
      </label>
    </>
  );
};
